import {
  Component,
  ElementRef,
  HostBinding,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  Future,
  Instrument
} from '@iv/model/instrument';
import { AppState } from '@iv/store/app.reducer';
import { AppStore } from '@iv/store/app.store';
import * as Redux from 'redux';
import { getCurrentTab } from '@iv/store/tabs/tabs.selectors';
import * as TabsActions from '../../store/tabs/tabs.actions';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonService } from '../../core/services/common.service';
import { IVX30ChartComponent } from 'app/charts/components/ivx30-chart/ivx30-chart.component';
import { TabTypeEnum } from '@iv/model/tabs.model';

@Component({
  selector: 'iv-live-workspace',
  templateUrl: './workspace.component.html',
  styleUrls: ['./workspace.component.scss']
})
export class WorkspaceComponent implements OnInit, OnDestroy {

  constructor(
    private commonService: CommonService,
    @Inject(AppStore) private store: Redux.Store<AppState>,
    private sanitizer: DomSanitizer, private _eref: ElementRef
  ) {
    const me = this;
    this.unsubscribeStore = store.subscribe(() => this.updateState());
    this.updateState();
    this.onMouseMove = this.resize.bind(this);

    this.onMouseUp = (function () {
      const handler = function () {
        if (me.frame) {
          me.frame.removeEventListener('mousemove', me.onMouseMove, true);
          me.frame.removeEventListener('mouseup', me.onMouseUp, true);
          me.frame = undefined;
        }
        document.removeEventListener('mousemove', me.onMouseMove, true);
        document.removeEventListener('mouseup', handler, true);
      };
      return handler;
    })();
  }

  @ViewChild
  ('service', {static: false}) service !: ElementRef;
  @ViewChild
  (IVX30ChartComponent, {static: false}) fsMode;

  @HostBinding
  ('class.no-options') noOptions;
  @HostBinding
  ('style.gridTemplateRows') gridRows = this.sanitizer.bypassSecurityTrustStyle('300px 15px minmax(300px, 1fr)');

  public currentTab = getCurrentTab(this.store.getState());
  public ivx = '30';
  public hv = this.currentTab.type === TabTypeEnum.OPTION_CHAIN ? '20' : '30';
  public HV;
  public IVX;
  public stockInfo;
  public isClose = true;
  public chartHeight = 'auto';
  public ivx30Url: string;

  private unsubscribeStore;
  private height = 0;
  private serviceTabs: any;
  private onMouseMove;
  private onMouseUp;
  private frame;

  private _instrument: Instrument | Future;

  get instrument(): Instrument | Future {
    return this._instrument;
  }

  set instrument(value: Instrument | Future) {
    this._instrument = value;
  }

  private _hideCharts = false;

  @HostBinding('class.short') get hideCharts(): boolean {
    return this._hideCharts;
  }

  set hideCharts(value: boolean) {
    this._hideCharts = value;
  }

  public ngOnInit(): void {
    this.noOptions = !this.instrument.hasOptions;
    if (this.instrument.regionId === 3) {
      this.hv = '30';
    }
    this.height = this._eref.nativeElement.clientHeight;
    if (!this._hideCharts) {
      // todo временный костыль, потом разобраться
      this._hideCharts = true;
      setTimeout(() => {
        this._hideCharts = false;
      }, 200);
    }
  }

  public ngOnDestroy(): void {
    if (typeof this.unsubscribeStore === 'function') {
      this.unsubscribeStore();
    }
  }

  changeHv(hv) {
    this.hv = hv;
  }

  changeIvx(ivx) {
    this.ivx = ivx;
  }

  fs() {
    if (!this.fsMode) return;
    if (this.fsMode.fsMode) this.chartHeight = (window.innerHeight - 60) + 'px'; else this.chartHeight = 'auto';
    return this.fsMode ? this.fsMode.fsMode : null;
  }

  updateState() {
    if (!this.ivx30Url) {
      this.ivx30Url = this.currentTab.type === TabTypeEnum.OPTION_CHAIN ? '/tradingview' : '/futures-tradingview';
    }

    this.instrument = this.currentTab.type === TabTypeEnum.OPTION_CHAIN ? this.currentTab.data.instrument : this.currentTab.data.future;

    // TODO: Временно, пока в future нет hasOptions. Убрать как появятся
    if (this.currentTab.type === TabTypeEnum.FUTURES_OPTION_CHAIN) {
      this.instrument.hasOptions = true;
    }
    this.serviceTabs = this.currentTab.data.serviceTabs;
    this.hideCharts = this.currentTab.data.hideCharts;
  }

  onToggle(e): void {
    e.preventDefault();
    this.store.dispatch(TabsActions.updateTabData({
      name: 'hideCharts',
      value: !this.hideCharts
    }));
    this._hideChart(this.hideCharts);
  }

  resize(e) {
    this.height = this._eref.nativeElement.clientHeight;
    const chart = <HTMLElement>document.getElementsByClassName('ivx30-chart')[0];
    const chartHeight = chart.clientHeight + e.movementY;
    let height = parseFloat(getComputedStyle(this.service.nativeElement, '').height) - e.movementY;

    if (height >= 200) {
      if (height > (this.height - chartHeight)) {
        height = this.height - chartHeight;
      }
      this.gridRows = this.sanitizer.bypassSecurityTrustStyle('auto 15px ' + height + 'px');
    }
    if (this.frame === undefined) {
      const f = <HTMLIFrameElement>document.getElementsByTagName('IFRAME')[0];
      if (f) {
        this.frame = f.contentWindow.document;
      }
      this.frame.addEventListener('mousemove', this.onMouseMove, true);
      this.frame.addEventListener('mouseup', this.onMouseUp, true);
    }
    e.preventDefault();
  }

  onMouseDown() {
    if (!this.hideCharts) {
      if (this.frame === undefined) {
        const f = <HTMLIFrameElement>document.getElementsByTagName('IFRAME')[0];
        if (f) {
          this.frame = f.contentWindow.document;
          this.frame.addEventListener('mousemove', this.onMouseMove, true);
          this.frame.addEventListener('mouseup', this.onMouseUp, true);
        }
      }
      document.addEventListener('mousemove', this.onMouseMove, true);
      document.addEventListener('mouseup', this.onMouseUp, true);
    }
  }

  private _hideChart(hide) {
    this.commonService.hideChart(hide);
  }
}
